import { Route } from 'react-router-dom';
import { IntegrationsPage, IntegrationDetailsPage, HubspotOAuth } from '@hotjar/integrations';
import {
  AuthenticatedRoute,
  ErrorBoundaryRoute,
  SiteAccessRequiredRoute,
} from '@hotjar/webapp-routing';
import { IntegrationsContext } from '@hotjar/webapp/contexts/integrations';
import { SETTINGS } from '@hotjar/webapp/constants/routes';

export const IntegrationsRoutes = (): JSX.Element => {
  return (
    <>
      <Route
        path={SETTINGS.INTEGRATIONS.path}
        element={
          <AuthenticatedRoute>
            <ErrorBoundaryRoute squadSentryTag="integrations" featureName="integrations">
              <IntegrationsContext>
                <IntegrationsPage />
              </IntegrationsContext>
            </ErrorBoundaryRoute>
          </AuthenticatedRoute>
        }
      />
      <Route
        path={SETTINGS.INTEGRATION_DETAILS.path}
        element={
          <SiteAccessRequiredRoute>
            <AuthenticatedRoute>
              <ErrorBoundaryRoute squadSentryTag="integrations" featureName="integrations.details">
                <IntegrationsContext>
                  <IntegrationDetailsPage />
                </IntegrationsContext>
              </ErrorBoundaryRoute>
            </AuthenticatedRoute>
          </SiteAccessRequiredRoute>
        }
      />
      <Route
        path={SETTINGS.INTEGRATIONS_HUBSPOT_OAUTH_REDIRECT.path}
        element={
          <AuthenticatedRoute>
            <ErrorBoundaryRoute
              squadSentryTag="integrations"
              featureName="integrations.hubspot_oauth_redirect"
            >
              <IntegrationsContext>
                <HubspotOAuth />
              </IntegrationsContext>
            </ErrorBoundaryRoute>
          </AuthenticatedRoute>
        }
      />
    </>
  );
};
